export const INBOUND = 'INBOUND';
export const OUTBOUND = 'OUTBOUND';
export const BOTH = 'BOTH';